import request from '@/request/index';
import util from '@/libs/util';

// 基本信息保存修改
export function updataBasicNew(data) {
    return request({
        url: '/webapi/api/user_info',
        method: 'put',
        data
    });
}

// 基本信息查询
export function quertBasicNew(id) {
    return request({
        url: '/webapi/api/user_info/' +id,
        method: 'get'
    });
}

// 个人简历保存
export function resumeSave(data) {
    return request({
        url: '/webapi/api/user_resume',
        method: 'post',
        data
    });
}

// 个人简历查询
export function resumeQuery(id) {
    return request({
        url: '/webapi/api/user_resume/userresume_list/' +id,
        method: 'get'
    });
}

// 个人简历删除
export function resumedelete(id) {
    return request({
        url: '/webapi/api/user_resume/' +id,
        method: 'delete'
    });
}

// 指导老师或者推荐医师保存信息
export function saveTeacher(data) {
    return request({
        url: '/webapi/api/user_teacher',
        method: 'post',
        data
    });
}

// 获取考生填写的老师信息列表
export function getTeacherList(id, urlParms) {
    let parmas = (urlParms) ? '?' + (util.tool.urlPath(urlParms)) : "";
    return request({
        url: '/webapi/api/user_teacher/list/'+id + parmas,
        method: 'get'
    });
}

// 获取考生填写的老师详情信息
export function getTeacherDetail(id) {
    return request({
        url: '/webapi/api/user_teacher/'+id,
        method: 'get'
    });
}

//删除指导老师或推荐医师
export function DeleteTeacherNew(id) {
    return request({
        url: '/webapi/api/user_teacher/' + id,
        method: 'delete'
    });
}

//修改指导老师或推荐医师
export function updataTeacherNew(data) {
    return request({
        url: '/webapi/api/user_teacher',
        method: 'put',
        data
    });
}

// 报名提交
export function saveSignup(data) {
    return request({
        url: '/webapi/api/auditmain/submit2',
        method: 'post',
        data
    });
}




//项目提交


